/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * slim scroll
 * ======================================================================== 
 * 11/11/2015: creation
 * 5/2/2016:    new parent handler
 * 6/29/2016:   innosuite 2016
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};



    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="scroll"]';
    var APPLIST_ELEM = '#SITE_APP_LIST';


    //  defaults
    var defaults = {
        element: '',
        height: 200,
        color: '#444444',
        size: 7,
        width: 'none',
        alwaysVisible: false,
        destroy: true,
        resize: false,
        offset: 0,
        position: 'right',
        distance: '1px',
        disablefadeout: true,
        fullscreen: false,
        axis: 'y',
        wheelstep: 10,
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  get slimscroll
    function getScroll(container, viewProps) {
        var list = '';

        //  set list
        if (container !== null && container != undefined) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        //  get site view
        var siteView = 'cozy';
        if (viewProps !== undefined) siteView = viewProps.siteView;

        //  bail
        if (list.length === 0) return;

        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());
            options.element = elem;

            options.alwaysVisible = (options.alwaysvisible === true) ? true : false;
            setContainer(options, siteView);
        });       
    }



    //  set the containers
    function setContainer(options, siteView) {
        var e = options.element;

        if (e === null) return;

        //  destroy first
        if (options.destroy) {
            e.parent().find('.slimScrollBar').remove();
            e.parent().find('.slimScrollRail').remove();
            e.slimScroll({ destroy: true });
            e.attr('style', '');
        } 
        //  set on resize
        var height = options.height;
        if (options.resize) {
            height = me.getWindowHeight(options.offset);
        } else {
            height = setScrollHeight(options, siteView)          
        }

        if (typeof height == 'string' && height.indexOf("vh")) {
            height = "calc(" + height + " - " + $(".site-body-content").css("margin-top") + ")";
        }

        //  set on fullscreen || resize
        if (options.resize || options.fullscreen) {
            $(window).resize(function () {
                if (this.scrollDelay) clearTimeout(this.scrollDelay);
                this.scrollDelay = setTimeout(function () {
                    setContainer(options, siteView);
                }, 500);
            });
        }

        //  set slimscroll object
        e.slimScroll({
            height: height,
            width: options.width,
            color: options.color,
            size: options.size,
            position: options.position,
            distance: options.distance,
            alwaysVisible: options.alwaysVisible,
            disableFadeOut: options.disablefadeout,
            axis: options.axis,
            wheelStep: options.wheelstep,
        });

        if (!options.alwaysVisible) {
            $('.slimScrollBar').css({ display: 'none' });
        }
    }


    function setScrollHeight(options, siteView) {

        if (options.fullscreen) {
            var vpHeight = document.documentElement.clientHeight - 150;

            //  children count
            var childCount = $(APPLIST_ELEM).children().length || 1;
            var viewListMultiplier = 30;
            if (siteView === 'cozy') viewListMultiplier = 26;
            if (siteView === 'compact') viewListMultiplier = 24;
            var height = (viewListMultiplier * childCount);

            if (height > vpHeight) height = vpHeight;
            if (vpHeight < 220) height = 220;

            return height;
        }
 
        return options.height;
    }

    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set scroll
    child.setScroll = function (container) {
        var viewProps = me.getUserProps();

        getScroll(container, viewProps);
    };


    child.setScrollAfterSiteView = function (viewProps) {
        getScroll(null, viewProps);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));